(() => {
  const findPurchaseArea = (root) => {
    const customSelector = root.dataset.purchaseTarget?.trim();

    if (customSelector) {
      try {
        const customTarget = document.querySelector(customSelector);
        if (customTarget) return customTarget;
      } catch (error) {
        // Ignore invalid merchant-entered selectors and use theme fallbacks.
      }
    }

    return (
      document.querySelector('#MainContent product-form form[action*="/cart/add"]') ||
      document.querySelector('#MainContent form[action*="/cart/add"]') ||
      document.querySelector('#MainContent .product__info-container') ||
      document.querySelector('[id^="MainProduct-"]')
    );
  };

  const initBroochLanding = (root) => {
    if (!root || root.dataset.broochInitialized === 'true') return;

    root.dataset.broochInitialized = 'true';
    document.documentElement.classList.add('has-brooch-landing');
    const purchaseArea = findPurchaseArea(root);
    const mobileBar = root.querySelector('[data-brooch-mobile-bar]');
    const nativeStickyAtc = document.querySelector(
      'sticky-atc, [id^="sticky-atc-"], .sticky-atc:not(.brooch-landing__mobile-bar)'
    );

    if (nativeStickyAtc) {
      root.classList.add('has-native-sticky-atc');
      document.documentElement.classList.add('has-brooch-native-sticky');
    }

    root.querySelectorAll('[data-brooch-cta]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        const target = findPurchaseArea(root);
        if (!target) return;

        target.scrollIntoView({ behavior: 'smooth', block: 'center' });

        window.setTimeout(() => {
          const submitButton = target.querySelector('button[type="submit"], [name="add"]');
          submitButton?.focus({ preventScroll: true });
        }, 550);
      });
    });

    if (!mobileBar || root.dataset.stickyMobile !== 'true' || nativeStickyAtc) {
      mobileBar?.setAttribute('aria-hidden', 'true');
      return;
    }

    const updateMobileBar = () => {
      if (window.matchMedia('(min-width: 750px)').matches) {
        root.classList.remove('is-mobile-bar-visible');
        mobileBar.setAttribute('aria-hidden', 'true');
        return;
      }

      const reference = purchaseArea || root.querySelector('.brooch-landing__hero');
      const referenceRect = reference?.getBoundingClientRect();
      const rootRect = root.getBoundingClientRect();
      const shouldShow = Boolean(referenceRect && referenceRect.bottom < 0 && rootRect.bottom > 100);

      root.classList.toggle('is-mobile-bar-visible', shouldShow);
      mobileBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    let ticking = false;
    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        updateMobileBar();
        ticking = false;
      });
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateMobileBar();
  };

  const initAllBroochLandings = (scope = document) => {
    scope.querySelectorAll('[data-brooch-landing]').forEach(initBroochLanding);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllBroochLandings());
  } else {
    initAllBroochLandings();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllBroochLandings(event.target);
  });
})();
